/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { InvitationsControllerFindOneQueryResponse, InvitationsControllerFindOnePathParams, InvitationsControllerFindOne400, InvitationsControllerFindOne401, InvitationsControllerFindOne403, InvitationsControllerFindOne404 } from "../../models/invitationsController/InvitationsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { invitationsControllerFindOne } from "../../clients/invitationsService/invitationsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const invitationsControllerFindOneQueryKey = (id: InvitationsControllerFindOnePathParams["id"]) => [{
  url: '/api/v1/invitations/:id',
  params: {
    id: id
  }
}] as const;
export type InvitationsControllerFindOneQueryKey = ReturnType<typeof invitationsControllerFindOneQueryKey>;
export function invitationsControllerFindOneQueryOptions(id: InvitationsControllerFindOnePathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = invitationsControllerFindOneQueryKey(id);
  return queryOptions<InvitationsControllerFindOneQueryResponse, ResponseErrorConfig<InvitationsControllerFindOne400 | InvitationsControllerFindOne401 | InvitationsControllerFindOne403 | InvitationsControllerFindOne404>, InvitationsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return invitationsControllerFindOne(id, config);
    }
  });
}

/**
 * @description Retrieves a specific invitation by its ID.
 * @summary Get invitation by ID
 * {@link /api/v1/invitations/:id}
 */
export function useInvitationsControllerFindOne<TData = InvitationsControllerFindOneQueryResponse, TQueryData = InvitationsControllerFindOneQueryResponse, TQueryKey extends QueryKey = InvitationsControllerFindOneQueryKey>(id: InvitationsControllerFindOnePathParams["id"], options: {
  query?: Partial<QueryObserverOptions<InvitationsControllerFindOneQueryResponse, ResponseErrorConfig<InvitationsControllerFindOne400 | InvitationsControllerFindOne401 | InvitationsControllerFindOne403 | InvitationsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? invitationsControllerFindOneQueryKey(id);
  const query = useQuery({
    ...invitationsControllerFindOneQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<InvitationsControllerFindOne400 | InvitationsControllerFindOne401 | InvitationsControllerFindOne403 | InvitationsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}